<app-base-side-panel-modal>
  <ng-template #header>
    <div class="flex justify-start items-center gap-3">
      <svg-icon class="w-8 h-8 svg-dark" [src]="'edit'"></svg-icon>
      <div class="text-navy-90">
        {{ buildTranslationKey('overview.edit') | translate }}
      </div>
    </div>
  </ng-template>

  <ng-template #content>
    <div class="flex flex-col max-h-full overflow-hidden">
      <dynamic-form-outlet [dynamicFormGroup]="form"></dynamic-form-outlet>
    </div>
  </ng-template>

  <ng-template #footer>
    <app-new-button
      class="checkmark-button"
      [disabled]="form?.invalid || !wasFormValueChanged"
      [loading]="sendingRequestBtnLoader$ | async"
      [saveButtonSizeDuringLoading]="true"
      [type]="'primary'"
      [svgIconPath]="'checkmark'"
      [size]="'responsive'"
      (click)="save()"
    >
      {{ buildTranslationKey('saveChangesBtn') | translate }}
    </app-new-button>
  </ng-template>
</app-base-side-panel-modal>
